import { ConnectedPosition, Overlay } from '@angular/cdk/overlay';
import { ChangeDetectorRef, ComponentRef, Injectable } from '@angular/core';
import { BaseInfoService } from '../../account-wizard-helpers/services/base-info.service';
import { AccountExtensionView } from '../../add-account-extension/models/account-extension-view.model';
import { ExtensionInfoComponent } from '../extension-summary/extension-info.component';

@Injectable()
export class ExtensionInfoService extends BaseInfoService<ExtensionInfoComponent> {
   constructor(overlay: Overlay) {
      super(overlay, ExtensionInfoComponent, 'extension-info-panel');
   }

   protected updateComponentData(componentRef: ComponentRef<ExtensionInfoComponent>, data: AccountExtensionView): void {
      componentRef.instance.extension = data;
   }

   showExtensionInfo(
      extensionViewModel: AccountExtensionView,
      button: HTMLElement,
      changeDetectorRef?: ChangeDetectorRef
   ) {
      const connectedPositions: ConnectedPosition[] = [
         {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
         },
         {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom',
         },
      ];

      const outsidePointerEventsCallback = () => {
         this.selectedId = null;
         changeDetectorRef?.markForCheck();
         this.outsidePointerEvent$.next();
      };

      this.openOverlay(extensionViewModel, button, connectedPositions, outsidePointerEventsCallback.bind(this));

      if (this.selectedId === extensionViewModel.number) {
         this.selectedId = null;
      } else {
         this.selectedId = extensionViewModel.number ?? null;
      }
   }
}
